module.exports = "/React/dist/f6f56d0d7356b2615dd8e7792c44f28e.png";